// extracted by mini-css-extract-plugin
module.exports = {"MainMenu":"MainMenu_MainMenu__19uKs","sidebar":"MainMenu_sidebar__1Zyoo","open":"MainMenu_open__1CrPb","closed":"MainMenu_closed__faBdr","content":"MainMenu_content__8W_6J"};